/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Mission Operation Form for input view 
Author: Deimos Space UK

Version: 1.0
*/

import React, { useState, useEffect } from 'react'
import { Row, Col, Form, OverlayTrigger, Tooltip, } from 'react-bootstrap';
import Switch from "react-switch";
import style from '../MissionOperation.module.css'

function MissionOperationForm(props) {
  const [cam, setCamEfficacy] = useState('')
  const [status, setStatus] = useState('active')
  const [debrisTrackability, setDebrisTrackability] = useState('')
  const [missionOperationData, setMissionOperationData] = useState('')
  const [architectureType, setArchitectureType] = useState('')
  const [ares, setAres] = useState(false)
  const ChangeCamEfficacy = (value) => {
    setCamEfficacy(value)
    props.onChangeCamEfficacy(value, props.index)
  }

  const ChangeDebrisTrackability = (value) => {
    setDebrisTrackability(value)
    props.onChangeDebrisTrackability(value, props.index)
  }


  const ChangeAres = () => {
    setAres(!ares)
    props.onChangeEfficacy('', props.index)
    props.onChangeAcpl('', props.index)
  }


  useEffect(() => {
    if (props.step2 && props.step2[props.index] && props.step2[props.index].MissionOperation) {
      setCamEfficacy(props.step2[props.index].MissionOperation.cam)
      setStatus(props.step2[props.index].MissionOperation.camStatus)
      setDebrisTrackability(props.step2[props.index].MissionOperation.debrisTrackability)
      setMissionOperationData(props.step2[props.index].MissionOperation)
      if (props.step2[props.index].MissionOperation.acpl && props.step2[props.index].MissionOperation.cam === 'yes' && props.step2[props.index].MissionOperation.camStatus === 'active') {
        setAres(true)

      }
      if (missionOperationData.cam_efficacy) {
        setAres(false)
      }

      if (missionOperationData.acpl && missionOperationData.cam === 'yes' && missionOperationData.camStatus === 'active') {
        setAres(true)

      }
    }
    if (props.architectureType) {
      setArchitectureType(props.architectureType)
    }



  }, [missionOperationData.acpl, missionOperationData.cam, missionOperationData.camStatus, missionOperationData.cam_efficacy, props])

  return (
    <div style={{ width: '100%', }}>

      <Row>
        <Col xs={12}>
          <h4 style={{ color: '#003247', marginTop: '20px' }}>Mission operations</h4>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Row style={{ marginBottom: '15px' }}>
            {
              architectureType !== 'launcher' && (
                <Col xs={12} lg={4}>
                  <OverlayTrigger
                    key={'right'}
                    placement={'left'}
                    overlay={
                      <Tooltip id={`tooltip-right`}>
                        Collision Avoidance Manoeuver (CAM) capabilities. If available (YES), the spacecraft is considered to be able to perform CAM during all phases of the mission, with the exception of the Post Mission Disposal phase.
                      </Tooltip>
                    }>
                    <div style={{ color: '#003247', marginTop: '10px', display: 'inline-block' }}>
                      CAM capabilities
                    </div>
                  </OverlayTrigger>

                  <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                    <button disabled={props.disabled} onClick={() => { ChangeCamEfficacy('yes') }} style={{ color: cam !== 'yes' && '#003247', border: cam === 'yes' && '#003247', background: cam === 'yes' && '#003247' }} className={style.button}>Yes</button>
                    <button disabled={props.disabled} style={{ background: cam === 'no' && '#003247', color: cam !== 'no' && '#003247', border: cam === 'no' && '#003247' }} onClick={() => { ChangeCamEfficacy('no') }} className={style.button}>No</button>
                  </div>
                </Col>
              )
            }


            <Col xs={12} lg={4}>
              {(cam !== 'no' || architectureType === 'launcher') && (
                <div>
                  <OverlayTrigger
                    key={'right'}
                    placement={'left'}
                    overlay={
                      <Tooltip id={`tooltip-right`}>
                        Debris trackability refers to the minimum size of debris that are trackable from ground. When <span style={{ fontWeight: 'bold' }}>Constant</span> is selected, a fixed value of 0.1 m is considered. When <span style={{ fontWeight: 'bold' }}>Variable</span> is selected, the radar equation is considerd.
                        d = 0.32 * ((sma - R_E)/2000)^2
                        d = object diametre
                        sma = semi-major axis
                      </Tooltip>
                    }>
                    <div style={{ color: '#003247', marginTop: '10px' }}>Debris trackability</div>
                  </OverlayTrigger>
                  <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                    <button disabled={props.disabled} style={{ color: debrisTrackability !== 'Constant' && '#003247', background: debrisTrackability === 'Constant' && '#003247', border: debrisTrackability === 'Constant' && '#003247' }} onClick={() => { ChangeDebrisTrackability('Constant') }} className={style.button}>Constant</button>
                    <button disabled={props.disabled} style={{ background: debrisTrackability === 'Variable' && '#003247', color: debrisTrackability !== 'Variable' && '#003247', border: debrisTrackability === 'Variable' && '#003247' }} onClick={() => { ChangeDebrisTrackability('Variable') }} className={style.button}>Variable</button>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </Col>
        {
          architectureType !== 'launcher' && (
            <Col xs={12}>
              <Row className={style.rowForm} style={{ alignItems: 'flex-end' }}>
                <Col xs={12}>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                    {(cam !== 'no') && (
                      <>
                        <h5 style={{ color: '#003247', }}>Get from <a target="_blank" href='https://sdup.esoc.esa.int/drama/'> DRAMA/ARES</a></h5>
                        <Switch
                          disabled={props.disabled}
                          checked={ares}
                          onChange={ChangeAres}
                          onColor="#009bdb"
                          onHandleColor="#2e4149"
                          handleDiameter={20}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          height={15}
                          width={30}
                          className="react-switch"
                          id="material-switch"
                        />
                      </>
                    )}
                  </div>

                </Col>
                <Col xs={12}>
                  {
                    (cam !== 'no' && !ares) && (

                      <Form.Group >
                        <OverlayTrigger
                          key={'right'}
                          placement={'left'}
                          overlay={
                            <Tooltip id={`tooltip-right`}>
                              Collision Avoidance Manoeuvers efficacy. The CAM efficacy % should have values between 0-100%.
                            </Tooltip>
                          }>
                          <div style={{ color: '#003247' }}>CAM efficacy [%]</div>
                        </OverlayTrigger>
                        <Form.Control
                          disabled={props.disabled}
                          value={missionOperationData.cam_efficacy}
                          isInvalid={(isNaN(parseFloat(missionOperationData.cam_efficacy)) && missionOperationData.cam_efficacy !== '') || parseFloat(missionOperationData.cam_efficacy) < 0 || parseFloat(missionOperationData.cam_efficacy) > 100}
                          onChange={e => props.onChangeEfficacy(e.target.value, props.index)} type="text" />
                      </Form.Group>

                    )
                  }
                  {(ares && cam === 'yes') && (

                    <Form.Group >
                      <OverlayTrigger
                        key={'right'}
                        placement={'left'}
                        overlay={
                          <Tooltip id={`tooltip-right`}>

                            Accepted Collision Probability Level. Specify a value between 0 and 1.
                          </Tooltip>
                        }>
                        <div style={{ color: '#003247', display: 'inline-block' }}>ACPL (0-1)</div>
                      </OverlayTrigger>


                      <Form.Control
                        disabled={props.disabled}
                        value={missionOperationData.acpl}
                        isInvalid={(isNaN(parseFloat(missionOperationData.acpl)) && missionOperationData.acpl !== '') || parseFloat(missionOperationData.acpl) < 0 || parseFloat(missionOperationData.acpl) > 1}
                        onChange={e => props.onChangeAcpl(e.target.value, props.index)} type="text" />
                    </Form.Group>

                  )}

                </Col>
              </Row>
              <Row className={style.rowForm}>
                <Col xs={12}>
                  <Form.Group controlId="formBasicPassword">
                    <OverlayTrigger
                      key={'right'}
                      placement={'left'}
                      overlay={
                        <Tooltip id={`tooltip-right`}>
                          Post Mission Disposal success rate. The PMD success rate % should have values between 0-100%.
                        </Tooltip>
                      }>
                      <div style={{ color: '#003247', marginTop: '10px', display: 'inline-block' }}>PMD success rate [%]</div>
                    </OverlayTrigger>

                    <Form.Control
                      disabled={props.disabled}
                      value={missionOperationData.pmdSuccessRate}
                      isInvalid={(isNaN(parseFloat(missionOperationData.pmdSuccessRate)) && missionOperationData.pmdSuccessRate !== '') || parseFloat(missionOperationData.pmdSuccessRate) < 0 || parseFloat(missionOperationData.pmdSuccessRate) > 100}
                      onChange={e => props.onChangePmdSuccessRate(e.target.value, props.index)} type="text" />
                  </Form.Group>
                </Col>
              </Row>


            </Col>
          )
        }


      </Row>

    </div>
  )
}

export default MissionOperationForm